import React from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { translate } from 'containers/services/translate';
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from '@material-ui/core';
import { Checkbox } from '@material-ui/core';

import { get, isEmpty, uniqueId } from 'lodash';
import * as featureService from 'features/fflip-helpers';
import { FEATURES } from 'features/features';
import useDeepCompareEffect from 'use-deep-compare-effect';
import messages from 'containers/CourtManagerLegalProceedings/messages';
import {
  ASSIGN_EXPERT,
  ASSIGN_EXPERT_PROVISIORE,
  EMPTY_ASSIGN_EXPERT,
} from 'containers/data-structure';
import { FormContainer } from 'containers/CourtManagerLegalProceedings/AssignExpert/styled-components';
import { extractExpertCode } from 'containers/CourtManagerLegalProceedings/utils';

import { getValueByCode } from 'containers/CourtManagerLegalProceedings/Provision/utils';
import { resolveExpertiseType } from 'containers/CourtManagerLegalProceedings/utils';
import { useDispatch } from 'react-redux';
import { requestGetExpertUsers } from 'containers/CourtManagerLegalProceedings/actions';
import { VictimType } from 'typings/globalTypes';

export interface AssignExpertFormProps {
  intl: IntlShape;
  //UPLOAD PROPS
  assignExpert: {};
  setAssignExpertFields: Function;
  listings: any;
  corporealLawyers: any;
  corporealExperts: any;
  victims: Partial<VictimType>[];
}
const AssignExpertForm: React.FC<AssignExpertFormProps> = (
  props,
): JSX.Element => {
  const dispatch = useDispatch();
  const inputLabel = React.useRef<HTMLLabelElement>(null);

  const [assignedExperts, setAssignedExperts] = React.useState<string[]>([]);

  const handleChangeSelect = (event: any) => {
    const {
      target: { value },
    } = event;
    const formattedValue = value.filter((el: string) => el);
    setAssignedExperts(
      // On autofill we get a stringified value.
      formattedValue,
    );
    props.setAssignExpertFields({
      ...props.assignExpert,
      assignedExperts: formattedValue.map((element: any) => ({
        expertCode: element,
      })),
    });
  };
  const [victimState, setVictimState] = React.useState<any>([]);
  const handleChangeSelectVictim = (event: any) => {
    const {
      target: { value },
    } = event;
    setVictimState(value);
    props.setAssignExpertFields({
      ...props.assignExpert,
      [ASSIGN_EXPERT_PROVISIORE.VICTIM_IDS]: value,
    } as any);
    setAssignExpertForm({
      ...assignExpertForm,
      [ASSIGN_EXPERT_PROVISIORE.VICTIM_IDS]: value,
    } as any);
  };

  const [assignExpertForm, setAssignExpertForm] = React.useState({
    ...EMPTY_ASSIGN_EXPERT,
  });

  const handleChange = (field: string) => (
    event: React.ChangeEvent<{ name?: string | undefined; value: any }>,
  ) => {
    if (field === ASSIGN_EXPERT.TYPE) {
      dispatch(requestGetExpertUsers(resolveExpertiseType(event.target.value)));
      props.setAssignExpertFields({
        ...props.assignExpert,
        [ASSIGN_EXPERT_PROVISIORE.VICTIM_IDS]: [],
        [field]: event.target.value,
      });
      setAssignExpertForm({
        ...assignExpertForm,
        [ASSIGN_EXPERT_PROVISIORE.VICTIM_IDS]: [],
        [field]: event.target.value,
      } as any);

      const lawyerInfo = props.corporealLawyers.filter(
        (element: { attributes: { sagis_code: any } }) =>
          get(element, 'attributes.sagis_code[0]', '') ===
          get(props.assignExpert, [ASSIGN_EXPERT.LAWYER]),
      );

      const experts =
        lawyerInfo &&
        !isEmpty(get(lawyerInfo, '[0].attributes.experts_code[0]', [])) &&
        get(lawyerInfo, '[0].attributes.experts_code[0]', [])
          .split(',')
          .filter(
            (element: any) =>
              element.toString() ===
              get(
                props.corporealExperts,
                '[0].attributes.sagis_code[0]',
                '',
              ).toString(),
          );
      if (!isEmpty(experts)) {
        setAssignedExperts([get(experts, '[0]', null)]);
        props.setAssignExpertFields({
          ...props.assignExpert,
          [field]: event.target.value,
          assignedExperts: [get(experts, '[0]', null)].map((element: any) => ({
            expertCode: element,
          })),
        });
      }
    } else {
      props.setAssignExpertFields({
        ...props.assignExpert,
        [field]: event.target.value,
      });
      setAssignExpertForm({
        ...assignExpertForm,
        [field]: event.target.value,
      });
    }
  };

  const expert_nature = [
    {
      id: 1,
      title: translate(messages.medicalExpertise, props),
      isVisible: featureService.hasFeature(FEATURES.EXPERT_INTEGRATION),
    },
    {
      id: 2,
      title: translate(messages.accountingExpertise, props),
      isVisible: featureService.hasFeature(
        FEATURES.EXPERT_INTEGRATION_ACCOUNTING,
      ),
    },
  ];

  const allMedicalExperts =
    props.corporealExperts &&
    props.corporealExperts.filter(
      (element: { attributes: { sagis_code: any } }) =>
        !isEmpty(get(element?.attributes, 'sagis_code', '')),
    );

  useDeepCompareEffect(() => {
    if (!get(props.assignExpert, 'assignedExpert')) {
      const lawyerInfo = props.corporealLawyers.filter(
        (element: { attributes: { sagis_code: any } }) =>
          get(element, 'attributes.sagis_code[0]', '') ===
          get(props.assignExpert, [ASSIGN_EXPERT.LAWYER]),
      );

      const experts =
        !isEmpty(lawyerInfo) &&
        !isEmpty(get(lawyerInfo, '[0].attributes.experts_code[0]', [])) &&
        get(lawyerInfo, '[0].attributes.experts_code[0]', [])
          .split(',')
          .filter((element: any) =>
            extractExpertCode(props.corporealExperts).includes(
              element?.toString(),
            ),
          );
      setAssignedExperts([get(experts, '[0]')]);
      props.setAssignExpertFields({
        ...props.assignExpert,
        assignedExperts: [get(experts, '[0]')].map((element: any) => ({
          expertCode: element,
        })),
      });
    } else if (!isEmpty(get(props.assignExpert, 'assignedExperts'))) {
      setAssignedExperts(
        get(props.assignExpert, 'assignedExperts').map(
          (element: any) => element.expertCode,
        ),
      );
      props.setAssignExpertFields({
        ...props.assignExpert,
        assignedExperts: get(props.assignExpert, 'assignedExperts').map(
          (element: any) => ({
            expertCode: element.expertCode,
          }),
        ),
      });
    }
  }, [props.corporealExperts]);

  return (
    <FormContainer>
      <div className="subContainer fee-note-form">
        <FormControl>
          <InputLabel>{translate(messages.expertNature, props)}</InputLabel>
          <Select
            className="input"
            onChange={handleChange(ASSIGN_EXPERT.TYPE)}
            name={ASSIGN_EXPERT.TYPE}
            value={
              get(props.assignExpert, [ASSIGN_EXPERT.TYPE])
                ? get(props.assignExpert, [ASSIGN_EXPERT.TYPE])
                : null
            }
            disabled={false}
          >
            {expert_nature
              .filter(
                (element: { id: number; title: string; isVisible: boolean }) =>
                  element.isVisible,
              )
              .map(
                (element: {
                  id: number;
                  title: string;
                  isVisible: boolean;
                }) => (
                  <MenuItem value={element.id}>{element.title}</MenuItem>
                ),
              )}
          </Select>
        </FormControl>
        <FormControl className="input">
          <InputLabel ref={inputLabel} id="idd-label-id">
            {translate(messages.victimsTitle, props)}
          </InputLabel>
          <Select
            labelId="idd-label-id"
            name={ASSIGN_EXPERT_PROVISIORE.VICTIM_IDS}
            value={victimState}
            renderValue={(vic: any) =>
              ((vic as any).map(
                (element: any) =>
                  ((props.victims as any).find((el: any) => el.id === element)
                    ?.firstName +
                    ' ' +
                    (props.victims as any).find((el: any) => el.id === element)
                      ?.lastName) as any,
              ) as any).join(', ') as any
            }
            onChange={handleChangeSelectVictim}
            labelWidth={60}
            multiple
          >
            {!isEmpty(props.victims) &&
              props.victims.map((val: Partial<VictimType>) => (
                <MenuItem key={uniqueId('val.id')} value={val.id}>
                  <Checkbox
                    checked={String(victimState).indexOf(val?.id as any) > -1}
                  />
                  {val.firstName + ' ' + val.lastName}
                </MenuItem>
              ))}
          </Select>
        </FormControl>
        <FormControl className="input">
          <InputLabel ref={inputLabel} id="idd-label-id">
            {translate(messages.expertConseilField, props)}
          </InputLabel>
          <Select
            labelId="idd-label-id"
            name={ASSIGN_EXPERT.ASSIGNED_EXPERT}
            value={assignedExperts}
            renderValue={(assignedExperts: any) =>
              ((assignedExperts as any).map((element: any) =>
                getValueByCode(
                  element as string,
                  get(props.listings, 'intervenants'),
                ),
              ) as any).join(', ') as any
            }
            onChange={handleChangeSelect}
            labelWidth={60}
            multiple
          >
            {!isEmpty(allMedicalExperts) &&
              allMedicalExperts.map(
                (val: {
                  attributes: { sagis_code: [] };
                  firstName: string;
                  lastName: string;
                }) => (
                  <MenuItem
                    key={uniqueId('stackholder_')}
                    value={
                      get(val.attributes.sagis_code, '[0]')
                        ? get(val.attributes.sagis_code, '[0]')
                        : null
                    }
                  >
                    <Checkbox
                      checked={
                        assignedExperts.indexOf(
                          get(val.attributes.sagis_code, '[0]'),
                        ) > -1
                      }
                    />
                    {val.firstName + ' ' + val.lastName}
                  </MenuItem>
                ),
              )}
          </Select>
        </FormControl>
      </div>
    </FormContainer>
  );
};

export default injectIntl(AssignExpertForm);
